
import React from 'react';
import MindMapView from '../tools/MindMapView';
import SynthesisView from '../tools/SynthesisView'; // Used for Sintesi and Approfondimento (unified UI)
import QuizView from '../tools/QuizView';
import FlashcardView from '../tools/FlashcardView';
import { Loader2, AlertCircle } from 'lucide-react';

const ArtifactRenderer = ({ artifact, onComplete }) => {
    if (!artifact) return null;

    // Loading State
    if (artifact.content === null) {
        return (
            <div className="flex flex-col items-center justify-center p-12 bg-white rounded-xl shadow-sm border border-gray-100 min-h-[300px]">
                <div className="relative">
                    <div className="w-16 h-16 border-4 border-gray-100 border-t-blue-600 rounded-full animate-spin"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <Loader2 className="w-6 h-6 text-blue-600 animate-pulse" />
                    </div>
                </div>
                <h3 className="mt-6 text-lg font-bold text-gray-800">Stiamo generando il tuo contenuto...</h3>
                <p className="text-gray-500 mt-2 text-center max-w-sm">
                    L'intelligenza artificiale sta analizzando il materiale del corso per creare {artifact.name || 'il contenuto richiesto'}.
                </p>
            </div>
        );
    }

    // Error/Empty State
    if (!artifact.content && artifact.status === 'failed') {
        return (
            <div className="flex flex-col items-center justify-center p-12 bg-red-50 rounded-xl border border-red-100">
                <AlertCircle className="w-12 h-12 text-red-500 mb-4" />
                <h3 className="text-lg font-bold text-red-800">Generazione fallita</h3>
                <p className="text-red-600">Si è verificato un errore durante la generazione. Riprova più tardi.</p>
            </div>
        );
    }

    // Render based on type
    switch (artifact.type) {
        case 'mappa':
            return <MindMapView data={artifact.content} />;
        case 'approfondimento':
            const synthesisData = {
                title: artifact.name || 'Approfondimento',
                content: typeof artifact.content === 'string' ? artifact.content : (artifact.content.sections || []).map(s => `## ${s.heading}\n\n${s.content}`).join('\n\n')
            };
            return <SynthesisView data={synthesisData} />;
        case 'sintesi':
            const synthesisPayload = typeof artifact.content === 'string'
                ? { title: artifact.name, content: artifact.content }
                : artifact.content;
            return <SynthesisView data={synthesisPayload} />;
        case 'quiz':
            // Pass the onComplete prop down to QuizView
            return <QuizView data={{ ...artifact.content, onComplete }} />;
        case 'flashcard':
            return <FlashcardView data={artifact.content} />;
        default:
            return (
                <div className="p-4 bg-gray-100 rounded text-gray-500">
                    Tipo di artefatto non supportato: {artifact.type}
                </div>
            );
    }
};

export default ArtifactRenderer;
